export const getImageWithWidth = (url, width) =>
  url ? url.replace('w=1800', `w=${width}`).replace('h=1800', '') : '';
export const getImageWithHeight = (url, height) =>
  url ? url.replace('w=1800?', ``).replace('h=1800', `h=${height}`) : '';

const getSrcSetEntry = (url, width) =>
  `${getImageWithWidth(url, width)} ${width}w`;

export const getSrcSet = (url, widths = []) =>
  widths.map(width => getSrcSetEntry(url, width)).join(', ');
